import { Section } from "../../../../components/section";
import { useDidNotReachCustomerDialog } from "../DidNotReachCustomerDialog";
import { CallBeforeInvoiceReminderFee1DetailCard } from "./CallBeforeInvoiceReminderFee1DetailCard";
import { VerticalButtons, WhiteButton } from "../../../../components/new-button";
import { useDidReachCustomerDialog } from "../DidReachCustomerDialog";
import { Message } from "../../../../Message";
import { AdministratorActionData } from "../../../../workflow/administrator-action.hook";
import { PaymentCollectionTaskDocument } from "../../../../task/task.model";
import { useCallback } from "react";
import { DineroContactDocument } from "../../pending-approval/dinero-contact.model";

interface CallBeforeInvoiceReminderFee1TaskContextProps {
    task: PaymentCollectionTaskDocument;
    contact: DineroContactDocument;
    administratorAction: (data: AdministratorActionData | string) => void;
}

export const CallBeforeInvoiceReminderFee1TaskContext = (props: CallBeforeInvoiceReminderFee1TaskContextProps) => {
    const { task, contact, administratorAction } = props;

    const registerDidNotReachCustomerAdapter = useCallback(() => {
        administratorAction({
            action: "register did not reach customer for call before invoice reminder fee 1",
            taskId: task.id,
        });
    }, [administratorAction, task.id]);
    const openDidNotReachCustomerDialog = useDidNotReachCustomerDialog(registerDidNotReachCustomerAdapter);

    const registerDidReachCustomerAdapter = useCallback((summary: string) => {
        administratorAction({
            action: "register did reach customer for call before invoice reminder fee 1",
            taskId: task.id,
            summary,
        });
    }, [administratorAction, task.id]);
    const openDidReachCustomerDialog = useDidReachCustomerDialog(registerDidReachCustomerAdapter);

    return (
        <Section>
            {task.hasBeenPerformed ? <Message>Opgaven er allerede blevet udført</Message> : null}

            <CallBeforeInvoiceReminderFee1DetailCard task={task} contact={contact} />

            {!task.hasBeenPerformed ? (
                <VerticalButtons>
                    <WhiteButton onClick={openDidNotReachCustomerDialog}>Jeg fik ikke fat i kunden</WhiteButton>
                    <WhiteButton onClick={openDidReachCustomerDialog}>Jeg fik fat i kunden</WhiteButton>
                </VerticalButtons>
            ) : null}

        </Section>
    );
};
